import {VendorOrderDetails} from "@pages/modal/vendorOrderDetails";
import {OrderDetails} from "@pages/modal/orderDetails";

export class PrintDataService {
    public orderData: VendorOrderDetails | undefined;
    public orderDetails: OrderDetails | undefined;
}